import { Flex } from '@mantine/core'

import { UserItem } from '@/modules/advisors/users/pages/chat/components/UserItem/UserItem'
import type { UsersListProps } from '@/modules/advisors/users/pages/chat/components/UsersList/UsersList.types'

import { Loader } from '@/components/Loader/Loader'
import { ScrollArea } from '@/components/ScrollArea/ScrollArea'
import { Text } from '@/components/Text/Text'

import classes from './UsersList.module.css'

export function UsersList({
  isLoading,
  onUserSelect,
  selectedUserId,
  users,
}: UsersListProps) {
  if (isLoading) {
    return (
      <Flex align="center" className={classes.container} justify="center">
        <Loader isMinimized />
      </Flex>
    )
  }

  if (!users.length) {
    return (
      <Flex align="center" className={classes.container} justify="center">
        <Text variant="body_1_grey">No users found</Text>
      </Flex>
    )
  }

  return (
    <Flex className={classes.container}>
      <ScrollArea scrollbars="y">
        {users.map(user => (
          <UserItem
            key={user.id}
            onUserSelect={onUserSelect}
            selected={selectedUserId === user.id}
            user={user}
          />
        ))}
      </ScrollArea>
    </Flex>
  )
}
